interface ConfirmationCodeFormProps {
  sharedValues: {
    email: string
  }
}

const ConfirmForgotPassword: React.FC<ConfirmationCodeFormProps> = ({
  sharedValues: { email },
}) => {
  return (
    <h1 className="mx-auto w-[95%] sm:w-[437px]">
      Thank you for your reset password request. An email has been sent to{' '}
      {email}. <br />
    </h1>
  )
}

export default ConfirmForgotPassword
